export default "__VITE_PUBLIC_ASSET__41d44004__"